module.exports = __webpack_public_path__ + "static/media/Iris Street, San Francisco, CA14.97411461.jpg";